import React from 'react';
import { styled } from 'baseui';
import { useStyletron } from 'baseui';
import { KIND as TAG_KIND, Tag } from 'baseui/tag';
import type { Theme } from 'baseui/theme';
import { ParagraphMedium } from 'baseui/typography';
import type { HeaderInfoT } from '../annotations/types';
type PropsT = {
  label: string;
  headerInfo: HeaderInfoT;
  icon: React.ReactNode;
};
const Container = styled<'div', {
  $isVisible: boolean;
}>('div', ({
  $theme,
  $isVisible
}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: $theme.sizing.scale500,
  opacity: $isVisible ? 1 : 0.5
}));
const LabelText = styled(ParagraphMedium, {
  margin: 0,
  '::first-letter': {
    textTransform: 'capitalize'
  },
  wordBreak: 'break-all'
});
const tagOverrides = {
  Root: {
    style: ({
      $theme
    }: {
      $theme: Theme;
    }) => ({
      margin: 0,
      backgroundColor: $theme.colors.contentInverseTertiary,
      padding: $theme.sizing.scale100,
      height: $theme.sizing.scale700
    })
  },
  Text: {
    style: ({
      $theme
    }: {
      $theme: Theme;
    }) => ({
      color: $theme.colors.backgroundAlwaysLight,
      ...$theme.typography.LabelXSmall
    })
  }
};
export function HeaderContent({
  label,
  headerInfo,
  icon
}: PropsT) {
  const {
    annotationCount,
    isVisible
  } = headerInfo;
  const [css] = useStyletron();
  return <Container $isVisible={isVisible}>
      <span className={css({
      display: 'flex',
      alignItems: 'center'
    })}>{icon}</span>
      <LabelText>{label}</LabelText>
      <Tag closeable={false} kind={TAG_KIND.primary} overrides={tagOverrides}>
        {annotationCount}
      </Tag>
    </Container>;
}